module.exports = __webpack_public_path__ + "static/internships-bd33eb21ae046f66273f2188079d768f.png";